angular.module('sfx.api.v2').factory('detectorv2Service', [
    'createV2Service',
    function (createV2Service) {
        return createV2Service('detector');
    },
]);
